import { WalletType } from '@/context/types';

import type { WalletConnector } from './connector';
import { loadSnapImplementation } from './snap-wallet-reader';

let satsConnect: typeof import('@sats-connect/core') | undefined;

export function clearDefaultWalletProvider(): void {
  satsConnect?.removeDefaultProvider();
}

const loaded = new Map<WalletType, WalletConnector>();
const pending = new Map<WalletType, Promise<WalletConnector>>();

export function loadWalletConnector(type: WalletType): Promise<WalletConnector> {
  const existing = pending.get(type);
  if (existing) return existing;
  const request = (async () => {
    switch (type) {
      case WalletType.Xverse:
        satsConnect = await import('@sats-connect/core');
        return (await import('./connector')).WALLET_CONNECTOR;
      case WalletType.Unisat:
        return (await import('./connector-unisat')).UNISAT_CONNECTOR;
      case WalletType.Metamask:
        return (await loadSnapImplementation()).METAMASK_SNAP_CONNECTOR;
      default:
        throw new Error(`Unsupported wallet type: ${type}`);
    }
  })()
    .then((connector) => {
      loaded.set(type, connector);
      return connector;
    })
    .catch((error: unknown) => {
      pending.delete(type);
      throw error;
    });
  pending.set(type, request);
  return request;
}

/** Synchronous access is reserved for already-connected wallet operations and listeners. */
export function getWalletConnector(type: WalletType): WalletConnector {
  const connector = loaded.get(type);
  if (!connector) throw new Error('Wallet connection is not ready. Please reconnect.');
  if (type === WalletType.Xverse) satsConnect?.setDefaultProvider('XverseProviders.BitcoinProvider');
  return connector;
}
